import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Vessel, VesselType, VesselsService } from '../../vessels.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { DocumentReference } from 'src/app/documents/documents.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { Versioned } from 'src/app/shared/helpers/versioned';
import { VesselSpec } from 'src/app/generated/services/transportation/vessels/vessel';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
@Component({
  selector: 'app-vessel-spec',
  templateUrl: './vessel-spec.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MatSelectModule,
    MaterialOrganisationSelectorComponent,
    MaterialChunkFileUploadComponent,
    MaterialPgInputComponent,
    MaterialPgButtonComponent,
    MatFormFieldModule,
    MaterialAutoCompleteComponent,
  ]
})
export class VesselSpecComponent implements OnInit {
  versionedVessel!: Versioned<Vessel>;
  owners: Organisation[] = [];
  technicals: Organisation[] = [];
  commercials: Organisation[] = [];
  owner!: Organisation;
  technical!: Organisation;
  commercial!: Organisation;
  vesselBuilder!: Organisation;
  builders: Organisation[] = [];
  manager!: Organisation;
  managers: Organisation[] = [];
  protector!: Organisation;
  protectors: Organisation[] = [];
  lastDryDock = '';
  nextDryDock = '';
  maximumBallastSpeed = 0;
  economicalLadenSpeed = 0;
  doc?: DocumentReference;
  doc2?: DocumentReference;

  vesselTypes!: Observable<VesselType[]>;
  title = new EventEmitter<string>();

  constructor(private _vesselsService: VesselsService,
    private _activateRoute: ActivatedRoute,
    private _organisationService: OrganisationService,
    private _pgMessagesService: PgMessagesService) { }

  ngOnInit(): void {
    this.vesselTypes = this._vesselsService.getVesselTypes();
    this._organisationService.get().subscribe(
      oranisation => {
        this.owners = oranisation.filter(
          (x) => x.properties['owner'] === true
        );
        this.technicals = oranisation.filter(
          (x) => x.properties['commercial'] === true
        );
        this.commercials = oranisation.filter(
          (x) => x.properties['technical'] === true
        );
        this.builders = oranisation.filter(
          (x) => x.properties['vesselBuilder'] === true
        );
        this.protectors = oranisation.filter(
          (x) => x.properties['vesselProtector'] === true
        );
        this.managers = oranisation.filter(
          (x) => x.properties['vesselManager'] === true
        );
      }
    );
    this._activateRoute.params.subscribe(params => {
      // const imo = params['imo'];
      // if (imo)
      const imo = params['imo'];
      if (!imo || imo === 'null' || imo === 'undefined') {
        return '';
      }
      forkJoin([
        this._vesselsService.getVessel(imo),
        this._organisationService.get()
      ]).subscribe(result => {
        this.versionedVessel = result[0];
        this.title.emit(`Spec For ${this.versionedVessel?.data?.name?.name}`);
        this.lastDryDock = this.versionedVessel?.data?.spec?.dryDock?.lastDryDock ?? '';
        this.nextDryDock = this.versionedVessel?.data?.spec?.dryDock?.nextDryDock ?? '';
        this.economicalLadenSpeed = (this.versionedVessel?.data?.spec?.charterPartySpeed) ? this.versionedVessel?.data?.spec.charterPartySpeed.economicalLadenSpeed : 0;
        this.maximumBallastSpeed = (this.versionedVessel?.data?.spec?.charterPartySpeed) ? this.versionedVessel?.data?.spec.charterPartySpeed.maximumBallastSpeed : 0;
        if(this.versionedVessel?.data?.spec?.ownershipOperationProtection) {
          this.owner = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.ownerId === x.name)!;
          this.technical = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.technicalOperatorId === x.name)!;
          this.vesselBuilder = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.builderId === x.name)!;
          this.protector = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.protectionIndemnityId === x.name)!;
          this.commercial = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.commercialOperatorId === x.name)!;
          this.manager = result[1].find(x => this.versionedVessel?.data?.spec?.ownershipOperationProtection?.managerId === x.name)!;
        }
      });

    });
  }

  save() {
    const spec = VesselSpec.create({
      ...this.versionedVessel?.data?.spec,
      charterPartySpeed: {
        economicalLadenSpeed: this.economicalLadenSpeed,
        maximumBallastSpeed: this.maximumBallastSpeed,
      },
      dryDock: {
        lastDryDock: this.lastDryDock,
        nextDryDock: this.nextDryDock
      }
    });
    this.versionedVessel.data!.spec = spec;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.ownerId = this.owner.name;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.technicalOperatorId = this.technical.name;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.commercialOperatorId = this.commercial.name;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.protectionIndemnityId = this.protector.name;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.builderId = this.vesselBuilder.name;
    this.versionedVessel.data!.spec!.ownershipOperationProtection!.managerId = this.manager.name;

    this._vesselsService.updateVessel(this.versionedVessel).subscribe((v) => {
      this.versionedVessel = v;
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        topic: 'Vessel',
        message: `The vessel ${this.versionedVessel?.data?.imo} information edited.`
      });
    },
    () => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Error,
        topic: 'Vessel',
        message: 'There is a problem to add this vessel.'
      });
    });
  }

  uploadDocument(r: DocumentReference) {
      this.versionedVessel.data!.spec!.shipParticularId = r.id;
  }

  vesselTypeFormatter(vesselType: VesselType): string {
    if (!vesselType) return '';
    return `${vesselType.name ?? ''} (${vesselType.code ?? ''})`;
  }
}
